import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContractDialogComponent } from '../contract-dialog/contract-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { switchMap, tap } from 'rxjs/operators';
import { EMPTY, Observable, of } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from "@angular/material/sort";
import { Contract } from "../../../model/contract";
import { ContractsService } from "../../../services/contracts.service";
import { DialogsService } from "../../../services/dialogs.service";
import { SnackService } from "../../../services/snack.service";
import { GeneralItemDetailDialogComponent } from "../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { AuthService } from "../../../services/auth.service";
import { UsersService } from "../../../services/users.service";
import { Constants } from "../../../utils/constants";
import { CreateContractDialogComponent } from "../create-contract-dialog/create-contract-dialog.component";
import { AddBoxesDialogComponent } from "../add-boxes-dialog/add-boxes-dialog.component";
import { DatePipe } from "@angular/common";
import { StatusLegendDialogComponent } from "../../../shared-components/status-dialog/status-legend-dialog.component";

@Component({
  selector: 'aw-list-contracts',
  templateUrl: './list-contracts.component.html',
  styleUrls: ['./list-contracts.component.scss']
})
export class ListContractsComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'title',
    'company',
    // 'email',
    'contractType',
    'startDate',
    'endDate',
    'extendedEndDate',
    'status',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  @ViewChild('paginatorContracts') paginatorContracts!: MatPaginator;
  dataSource!: MatTableDataSource<Contract>;
  roles = Constants.roles;
  contractStatus = Constants.contractStatuses;
  entities = Constants.entities;
  contractTypes = Constants.contractTypes;
  expandedContractEventsHistory?: Contract;
  expandedContractBoxes?: Contract;
  expandedCompany?: Contract;
  expandedTestbed?: Contract;
  loggedUser: any;
  iAmCustomer = false;
  iAmLogistic = false;
  iAmTester: boolean = false;

  private allContracts$!: Observable<Contract[]>;

  constructor(
    public dialog: MatDialog,
    public dialogsService: DialogsService,
    private contractsService: ContractsService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private userService: UsersService,
    private snackService: SnackService
  ) {
    this.loggedUser = this.authService.loggedUser();

    this.iAmCustomer = this.loggedUser.role === this.roles.customer;
    this.iAmLogistic = this.loggedUser.role === this.roles.logistic;
    this.iAmTester = this.loggedUser.role === this.roles.tester;
    if (this.iAmLogistic)
      this.displayedColumns.splice((this.displayedColumns.length - 6), 0, 'numberOfBoxes');
  }

  ngOnInit(): void {


  }

  ngAfterViewInit(): void {

    this.allContracts$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => {
            if (this.iAmCustomer) {
              return this.contractsService.getAllContractsByCompany(this.loggedUser.company.id);
            } else if (this.iAmLogistic) {
              return this.contractsService.getAllContracts([this.contractStatus.testbedAssociation, this.contractStatus.boxesWaiting, this.contractStatus.ongoing, this.contractStatus.extended]);
            } else if (this.iAmTester) {
              return this.contractsService.getAllContractsByCompany(this.loggedUser.company.id);
            }
            return this.contractsService.getAllContracts();

          }),
          tap(x => {

            if (this.iAmCustomer)
              x.forEach(contract => {
                if (contract.status === this.contractStatus.new && contract.createdBy?.role === this.roles.admin)
                  x.splice(x.findIndex(element => element.id === contract.id), 1);
              });

            this.dataSource = new MatTableDataSource<Contract>(x);
            this.dataSource.paginator = this.paginatorContracts;
            this.loading = false;
          })
        );
    this.allContracts$.subscribe();
  }

  expandCompany(element: Contract): void {

    this.expandedCompany != element ?
      this.expandedCompany = element :
      this.expandedCompany = undefined;

    this.expandedTestbed = undefined;
    this.expandedContractEventsHistory = undefined;
    this.expandedContractBoxes = undefined;
  }

  expandTestbed(element: Contract): void {

    this.expandedTestbed != element ?
      this.expandedTestbed = element :
      this.expandedTestbed = undefined;

    this.expandedContractEventsHistory = undefined;
    this.expandedContractBoxes = undefined;
    this.expandedCompany = undefined;
  }

  expandContractHistory(element: Contract): void {

    this.expandedContractEventsHistory != element ?
      this.expandedContractEventsHistory = element :
      this.expandedContractEventsHistory = undefined;

    this.expandedTestbed = undefined;
    this.expandedContractBoxes = undefined;
    this.expandedCompany = undefined;

  }

  expandBoxes(element: Contract): void {

    this.expandedContractBoxes != element ?
      this.expandedContractBoxes = element :
      this.expandedContractBoxes = undefined;

    this.expandedContractEventsHistory = undefined;
    this.expandedTestbed = undefined;
    this.expandedCompany = undefined;

  }

  applyFilters(event: string): void {
    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortContracts(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      const index: string = event.active;

      if (event.direction === 'asc') {
        return ('' + (b as any)[index]).localeCompare('' + (a as any)[index]);
      } else {
        return ('' + (a as any)[index]).localeCompare('' + (b as any)[index]);
      }

    });
  }

  details(contract: Contract): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: contract });
  }

  companyDetails(contract: Contract): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: contract.company });
  }

  performAction(contract: Contract): void {
    this.dialog.open(ContractDialogComponent, { data: contract })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allContracts$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  createContract(): void {
    this.disabled = true;
    this.dialog
      .open(CreateContractDialogComponent, { data: new Contract() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allContracts$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  editContract(contract: Contract): void {
    this.disabled = false;
    this.dialog
      .open(CreateContractDialogComponent, { data: contract })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allContracts$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });

  }

  deleteContract(contract: Contract): void {
    this.disabled = true;
    const id = contract.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete contract', `Are you sure you want to delete the contract "${contract.title}"?`)
      .pipe(
        switchMap((value) => value ?
          this.contractsService.deleteContract(<number>contract.id) :
          EMPTY),
        switchMap(() => this.allContracts$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Contract deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
          this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
        });

  }

  addBoxesToThisContract(contract: Contract): void {
    this.disabled = true;
    this.dialog.open(AddBoxesDialogComponent, { data: contract })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allContracts$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  getTooltip(contract: Contract): string {
    switch (contract.status) {
      case Constants.contractStatuses.new:
        if (this.loggedUser.role === this.roles.admin)
          return `You can edit contract's information. You can proceed to "Testbed Association" status only if you are the creator of this contract.`;
        else
          return `You can edit contract's information or proceed to "Approval Waiting" status.`;
      case Constants.contractStatuses.approvalWaiting:
        return Constants.contractStatusesExplainedForLegend.approvalWaiting;
      case Constants.contractStatuses.rejected:
        return Constants.contractStatusesExplainedForLegend.rejected;
      case Constants.contractStatuses.testbedAssociation:
        const stringForAdmin = this.loggedUser.role === this.roles.admin ? 'As an Administrator, you can set the contract to expired.' : '';
        return `${Constants.contractStatusesExplainedForLegend.testbedAssociation} ${stringForAdmin}`;
      case Constants.contractStatuses.boxesWaiting:
        return `Assign a box to the contract. The contract will begin on ${this.datePipe.transform(contract.startDate)}, but only if at least one box is assigned.`;
      case Constants.contractStatuses.ongoing:
        return `Contract can be extended by editing its "Extended end date" field. It will currently end on ${this.datePipe.transform(contract.endDate)}.`;
      case Constants.contractStatuses.extended:
        return `Contract can be extended by editing its "Extended end date" field. It will currently end on ${this.datePipe.transform(contract.extendedEndDate)}`;
      case Constants.contractStatuses.expired:
        return Constants.contractStatusesExplainedForLegend.expired;
      case Constants.contractStatuses.damageReported:
        return Constants.contractStatusesExplainedForLegend.damageReported;
      case Constants.contractStatuses.closed:
        return Constants.contractStatusesExplainedForLegend.closed;
      case Constants.contractStatuses.finalized:
        return Constants.contractStatusesExplainedForLegend.finalized;
      default:
        return 'not implemented!';
    }
  }

  statusDetails(): void {
    this.disabled = true;
    this.dialog.open(StatusLegendDialogComponent, { data: { contract: true, box: false } })
      .afterClosed()
      .pipe()
      .subscribe(
        () => {
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        }, () => {
          this.disabled = false;
        });
  }

  getBoxesTooltip(contract: Contract): string {

    return (contract.boxes?.length !== undefined && contract.numberOfBoxes !== undefined) && contract.boxes?.length < contract.numberOfBoxes ?
      `Number of requested boxes: ${contract.numberOfBoxes}
      Number of associated boxes: ${contract.boxes?.length}`
      :
      '';

  }
}
